module.exports = __webpack_public_path__ + "img/top.9366bea1.jpg";